import { useState } from 'react';
import { Header } from '@/components/layout/Header';
import { KeyAccessList } from '@/components/keys/KeyAccessList';
import { NearbyKeyReady } from '@/components/keys/NearbyKeyReady';
import { AddDeviceModal } from '@/components/devices/AddDeviceModal';

/**
 * KeysPage — fliken "Nycklar". Sammanslagningen av tidigare Nycklar och
 * Enheter: anläggningsmenyn (FacilityTabs) med gruppering per anläggning,
 * snabb öppning av nyckeln via tap på enheten (DevicePanel med QR, wallet,
 * tilldela, dela, info) samt hantering — lägg till enhet och ta bort egna
 * enheter.
 */
export default function KeysPage() {
  const [addModalOpen, setAddModalOpen] = useState(false);

  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main className="flex-1 space-y-6 px-4 py-6">
        <section className="animate-fade-in">
          <h1 className="text-2xl font-semibold tracking-tight truncate">Nycklar</h1>
        </section>

        {/* Nyckel redo — opt-in/status samt geofence-träffar */}
        <NearbyKeyReady showOptIn />

        <KeyAccessList showFacilityTabs allowRemove onAdd={() => setAddModalOpen(true)} />

        <AddDeviceModal open={addModalOpen} onOpenChange={setAddModalOpen} />
      </main>
    </div>
  );
}
